import { render, staticRenderFns } from "./CampaignParent.vue?vue&type=template&id=19503eff&"
import script from "./CampaignParent.vue?vue&type=script&lang=js&"
export * from "./CampaignParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports